module.exports = __webpack_public_path__ + "static/media/2.4ddfca63.jpg";